export const interceptProps =
  (excludes: string[]) =>
  (
    prop: string | number
    // defaultValidatorFn: (p: string | number) => boolean
  ) => {
    return !excludes.includes(String(prop));
    // && defaultValidatorFn(prop);
  };
